'use strict';

var materialIcon = require('../materialIcon');
var { getTranslation } = require('../common/jsTranslations');

function togglePassword($input, $btn, show) {
    $input.attr('type', show ? 'text' : 'password');
    $btn.attr('aria-label', getTranslation(show ? 'label.password.hide' : 'label.password.show'));
    $btn.attr('aria-pressed', show ? 'true' : 'false');
    $btn.find('span').html(show ? materialIcon.visibility : materialIcon.visibility_off);
}

/**
 * Initialize password visibility toggle buttons for every password input on
 * the page. Finds inputs, injects a toggle button into the nearest
 * .form-floating / .form-group wrapper, and handles click + keyboard events.
 */
function init() {
    $('input[type="password"]').each(function () {
        var $input = $(this);
        var $wrapper = $input.closest('.form-floating, .form-group');

        if (!$wrapper.length) {
            return;
        }

        $wrapper.addClass('password-toggle-wrapper');
        $input.addClass('pe-5');

        var $btn = $(`
            <button type="button" class="password-toggle-btn position-absolute right-0 translate-middle-y btn-reset p-3 lh-1 text-inherit cursor-pointer" aria-label="${getTranslation('label.password.show')}" aria-pressed="false">
                <span class="svg-wrapper-body-secondary material-icon-wrapper-x-small" aria-hidden="true">${materialIcon.visibility_off}</span>
            </button>
        `);

        $wrapper.append($btn);

        $btn.on('click', function () {
            togglePassword($input, $btn, $input.attr('type') === 'password');
        });
    });

    $(document).on('hide.bs.collapse', function (e) {
        $(e.target).find('.password-toggle-wrapper').each(function () {
            togglePassword($(this).find('input'), $(this).find('.password-toggle-btn'), false);
        });
    });
}

module.exports = init;
